import React = require("react");

import Activity = require("VersionControl/Scripts/Components/PullRequestReview/Activities/Activity");

class Component extends Activity.Component<Activity.IThreadActivityProps, Activity.IActivityState> {
    public render(): JSX.Element {
        return null;
    }
}

export function create(props: Activity.IThreadActivityProps): JSX.Element {
    return null;
}
